import React from "react";
import "./ui.css";

export default function Stat({ label, value, subtle }) {
  return (
    <div className="ui-stat">
      <div className="ui-stat__label">{label}</div>
      <div className="ui-stat__value">{value}</div>
      {subtle ? <div className="ui-stat__subtle">{subtle}</div> : null}
    </div>
  );
}
